import { CardContainer } from '@salescore/client-common'
import { getQueryParameter } from '@salescore/frontend-common'
import { createFileRoute, Link } from '@tanstack/react-router'
import { Button } from 'antd'

const Page = () => {
  const errorType = getQueryParameter('type')
  return (
    <CardContainer withLogo={false} size="medium">
      <>
        {errorType === 'user_not_found' ? (
          <div>
            <p>
              SALESCOREの利用には管理者からの登録が必要です。
              <br />
              あなたの組織のSALESCORE管理者、またはサポート担当に
              <br />
              ユーザーの登録をご依頼ください。
              <br />
            </p>
          </div>
        ) : // eslint-disable-next-line sonarjs/no-nested-conditional
        errorType === 'waiting_verification' ? (
          <div>
            <p>
              メールアドレスが認証されていません。
              <br />
              お送りした認証メールをご確認ください。
              <br />
            </p>
          </div>
        ) : (
          <div>エラーが発生しました</div>
        )}
        <Link to="/sign_out">
          <Button type="default">ログアウト</Button>
        </Link>
      </>
    </CardContainer>
  )
}

export const Route = createFileRoute('/error')({
  component: Page,
})
